__turbopack_context__.v({
  "testimonial": "E2jEeq_testimonial",
  "testimonial-caption": "E2jEeq_testimonial-caption",
  "testimonial-container": "E2jEeq_testimonial-container",
  "testimonial-heading": "E2jEeq_testimonial-heading",
  "testimonial-slide": "E2jEeq_testimonial-slide",
});
